<template>
  <div class="project-solarPlant">
    <AccessBlock
      v-if="showToGuest('baseConfiguration', guestVisibleSections)"
      :id="PROJECT_BASE_CONFIGURATION_BLOCK"
    >
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-solarplant-base-configuration
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-sliders mr-2"></i>{{ $t('baseConfiguration') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="project-solarplant-base-configuration" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectBaseConfiguration
                v-if="baseConfigurationBlock"
                :blockId="PROJECT_BASE_CONFIGURATION_BLOCK"
                :project="baseConfigurationBlock"
              />
              <p v-else-if="isNewProject" class="text-muted">
                {{ $t('saveNewProjectFirst') }}
              </p>
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>

    <AccessBlock
      v-if="showToGuest('extendedConfiguration', guestVisibleSections)"
      :id="PROJECT_EXTENDED_CONFIGURATION_BLOCK"
    >
      <div class="accordion" role="tablist">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.project-solarplant-extended-configuration
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-cogs mr-2"></i>{{ $t('extendedConfiguration') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse
            id="project-solarplant-extended-configuration"
            role="tabpanel"
            :visible="!isBaseConfigurationShown"
          >
            <div class="accordion-content px-2 py-2">
              <ProjectExtendedConfiguration
                v-if="extendedConfigurationBlock"
                :blockId="PROJECT_EXTENDED_CONFIGURATION_BLOCK"
                :project="extendedConfigurationBlock"
              />
              <p v-else-if="isNewProject" class="text-muted">
                {{ $t('saveNewProjectFirst') }}
              </p>
            </div>
          </b-collapse>
        </div>
      </div>
    </AccessBlock>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { showToGuest } from '@/helpers/userCapabilities';
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectBaseConfiguration from '@/blocks/project/ProjectBaseConfiguration.vue';
import ProjectExtendedConfiguration from '@/blocks/project/ProjectExtendedConfiguration.vue';
import {
  PROJECT_BASE_CONFIGURATION_BLOCK,
  PROJECT_EXTENDED_CONFIGURATION_BLOCK,
} from '@/navigation/accessNodes';

/**
 * Content of the project tab "Konfiguration" (group project-configuration-tab): one accordion
 * section per block, each inside its `AccessBlock` (ADR 0006 D5). Each block gets its excerpt
 * of `project.blocks` as `project`.
 */
export default {
  components: {
    AccessBlock,
    ProjectBaseConfiguration,
    ProjectExtendedConfiguration,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      PROJECT_BASE_CONFIGURATION_BLOCK,
      PROJECT_EXTENDED_CONFIGURATION_BLOCK,
      guestVisibleSections: {
        baseConfiguration: true,
        extendedConfiguration: false,
      },
    };
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    /** Block data from `Project.blocks`; null when the block was not loaded or denied. */
    baseConfigurationBlock() {
      return this.project?.blocks?.baseConfiguration ?? null;
    },
    extendedConfigurationBlock() {
      return this.project?.blocks?.extendedConfiguration ?? null;
    },
    /** A new project has no blocks until its first save; the blocks save by project number. */
    isNewProject() {
      return this.project?.number === '_new';
    },
    /** The extended section opens by default when the base section is not shown. */
    isBaseConfigurationShown() {
      return (
        this.showToGuest('baseConfiguration', this.guestVisibleSections) &&
        this.getAccessLevel(PROJECT_BASE_CONFIGURATION_BLOCK) !== null
      );
    },
  },
  methods: {
    showToGuest,
  },
};
</script>
